// A gazelle, modelled facing +X: a slender tan body with a white belly, slim
// legs, a graceful neck and curved horns. Ported 1:1 from age-of-mcp's classic
// gazelle.ts, restoring its leg loop + body/neck/head/horn composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.05, 0.025], [0.05, -0.025], [-0.05, 0.025], [-0.05, -0.025]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.005, 0.004, 0.115, 4),
      color: "#b08a52", position: [x!, 0.0575, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#cda468",
      position: [0, 0.115, 0], scale: [1.7, 0.95, 0.85] },           // body
    { geometry: new THREE.IcosahedronGeometry(0.022, 0), color: "#efe6d4",
      position: [0.012, 0.092, 0], scale: [1.5, 0.7, 1] },           // white belly
    { geometry: new THREE.CylinderGeometry(0.015, 0.02, 0.06, 5), color: "#cda468",
      position: [0.085, 0.14, 0], rotation: [0, 0, -0.7] },         // neck
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#d4ad70",
      position: [0.115, 0.165, 0] },                                 // head
    { geometry: new THREE.ConeGeometry(0.004, 0.04, 4), color: "#2e2620",
      position: [0.108, 0.2, 0.01], rotation: [0, 0, -0.2] },        // horn
    { geometry: new THREE.ConeGeometry(0.004, 0.04, 4), color: "#2e2620",
      position: [0.108, 0.2, -0.01], rotation: [0, 0, -0.2] },
  );
  return parts;
}

export const gazelle = defineModel({
  id: "gazelle",
  batchId: "standard",
  name: "Gazelle",
  tags: ["creature","gazelle","low-poly","age-of-mcp","classic"],
  summary: "Low-poly gazelle.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.12,
  parts: () => partsFor(),
  animations: [],
});
